import { useEffect, useState } from "react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { getClothes, getCollections } from "@store/slices";
import { useAppSelector } from "@hooks/useAppSelector";
import {
  getClothesAmountSelector,
  getClothesSelector,
  getCollectionsSelector,
} from "@store/selectors";
import { ProductCard } from "@ui-kit/productCard";
import { FilterSelectsCollections } from "@features/collections";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loader } from "@ui-kit/loader";
import { CustomPagination } from "@ui-kit/pagination";
import { SEO } from "@utils/SEO";
import { RoutePath } from "@router/routePath";
import styles from "./CollectionLayout.module.scss";

export const CollectionLayout = () => {
  const [collection, setCollection]: any = useState();
  const { t } = useTranslation();
  const location = useLocation();
  const url = location.search;
  const params = new URLSearchParams(url);
  const collectionName = decodeURIComponent(params.get("collectionId") || "");
  const collectionList = useAppSelector(getCollectionsSelector);
  const clothes = useAppSelector(getClothesSelector);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const skip = params.get("skip") || 0;
  const pageSize = params.get("limit") || 20;
  const pageNum = params.get("page") || 1;
  const amount = useAppSelector(getClothesAmountSelector);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handlePageChange = (page: number, pageSizeNum: number) => {
    searchParams.set("skip", ((page - 1) * pageSizeNum).toString());
    searchParams.set("limit", pageSizeNum.toString());
    searchParams.set("page", page.toString());
    setSearchParams(searchParams);
  };

  function findItemByName(name: any) {
    return collectionList.find((item) => String(item.id) === name);
  }

  useEffect(() => {
    if (!collectionName && collectionList.length) {
      navigate(`${RoutePath.collections}?collectionId=${collectionList[0].id}`);
    }
  }, [collectionList]);

  useEffect(() => {
    const categoryResult = findItemByName(collectionName);
    setCollection(categoryResult);
  }, [collectionList, collectionName]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [skip]);

  useEffect(() => {
    dispatch(getCollections());
    handlePageChange(Number(pageNum), Number(pageSize));
  }, [url]);

  useEffect(() => {
    const requestParams = new URLSearchParams(url);
    requestParams.delete("page");
    setLoading(true);
    dispatch(getClothes({ params: `?${requestParams.toString()}` })).then(
      () => {
        setLoading(false);
      }
    );
  }, [url]);

  return (
    <div className={styles.mainBlock}>
      <SEO
        title={t("header.collections")}
        url={`/collections?collectionId=${collection && collection.id}`}
      />

      <div className={styles.block}>
        <img
          src={collection && collection.image}
          alt=""
          className={styles.categoryImage}
        />
        <div className={styles.title}>{collection && collection.name}</div>
      </div>
      <div className={styles.filter}>
        <FilterSelectsCollections
          skip={skip}
          pageSize={pageSize}
          pageNum={pageNum}
        />
      </div>
      <div className={styles.cardBlcok}>
        {clothes.length ? (
          clothes.map((item) => <ProductCard data={item} key={item.id} />)
        ) : (
          <div className={styles.spin}>
            {loading ? (
              <Loader />
            ) : (
              <span className={styles.emptyDesc}>{t("category.form")}</span>
            )}
          </div>
        )}
      </div>
      <div className={styles.pagination}>
        {amount >= 19 && (
          <CustomPagination
            current={Number(pageNum)}
            pageSize={Number(pageSize)}
            total={amount}
            onChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};
